export default __webpack_public_path__ + "assets/470a6d01ac5543c1647e4901d75c1488.png";